/** Croix pour vider un champ de recherche. */
import "./searchClear.css";

type SearchClearProps = {
  value: string;
  onClear: () => void;
};

export function SearchClear({ value, onClear }: SearchClearProps) {
  if (!value) return null;
  return (
    <button
      type="button"
      className="fx-search-x"
      aria-label="Effacer la recherche"
      onMouseDown={(e) => e.preventDefault()}
      onClick={onClear}
    >
      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M6 6l12 12M18 6L6 18" />
      </svg>
    </button>
  );
}
